// extracted by mini-css-extract-plugin
export default {"wrapper":"Radio_wrapper__g4OxX","input":"Radio_input__QEkxc","label":"Radio_label__sZ0Uz"};